import moment from "moment/moment";


const defineDay = (item) => {
   if(item.data?.day){
       return item.data.day
   }else{
       return Array(7).fill({slotLeft: item.data.slots4, bookingCheck: true })
   }
}

export const mapCourseItem = (item, booked, dateValue, selectDay, isDesktop) => {
    const day = defineDay(item);
    let days = Object.values(day).splice(0, isDesktop ? 7 : 5)
    let today = moment().startOf("day");

    const checkWeekendOff = (targetDay) => {
        // console.log({ targetDay, satOff: courseData.data?.satOff });
        if ((!!item.data?.weekendOff && targetDay === 6) || (!!item.data?.weekendOff && targetDay === 0))
            return true;
        else return false;
    };

    return {
        ...item,
        data: {
            ...item.data,
            preview: `/tinypng/${item.data.imgName}.png`,
            day: days.map(
                (i, index) => {
                    const targetDate = moment(dateValue).add(index, "days").startOf("day");
                    const disabled =
                        item.data.preOrderDays <= Math.abs(moment.duration(today.diff(targetDate)).asDays()) || checkWeekendOff(targetDate.day())
                    const bookedSlots = booked[moment(dateValue).add(index, "days").format("DD/MM/YYYY")]
                    const nexSlo = bookedSlots?.filter(book => book?.data?.course?.data?.docName == item?.data?.docName) || [];
                    // console.log('[[day]]', targetDate.day())
                    const dayItem = {
                        ...i,
                        slotLeft: Math.max(0, i.slotLeft - nexSlo.length),
                        day: targetDate.format("DD.MM"),
                        disabled,

                    };
                    return {
                        ...dayItem,
                        onClick: () => {
                            selectDay(item, index, dayItem)
                        }
                    }
                }
            )
        }
    }
}
